import api from '../api/api'
import {GetDomain} from '../libs/tools'

const actions = {
  // 获取平台信息
  getPlatform: function ({commit}) {
    return new Promise((resolve, reject) => {
      try {
        let domain = GetDomain()
        api.getPlatforms({
          host: domain
        }).then(res => {
          if (res.code === 200) {
            commit('setPlatform', res.response.code)
            api.getPlatFormsInfoByHeader({}).then(res => {
              if (res.code === 200) {
                commit('setPlatformInfo', res.response)
                resolve()
              }
            })
          }
        }).catch(err => {
          reject(err)
        })
      } catch (error) {
        reject(error)
      }
    })
  }

}
export default actions
